<template>
  <div>
    <validation-observer ref="emissionUserInfoFormValidator">
      <v-form>
        <v-card>
          <v-card-title>招待情報の入力</v-card-title>
          <v-card-subtitle>
            招待情報の入力を行います。<br />
          </v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="氏名"
                  rules="required|max:12"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="name"
                    :error-messages="errors"
                    autocomplete="username"
                    label="氏名"
                    placeholder="例）テスト　太郎"
                    prepend-icon="mdi-account-outline"
                    hide-details="auto"
                  >
                    <template v-slot:label>
                      <span>氏名</span>
                      <span class="ml-1">
                        ({{ name?.length || 0 }} / 12)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="メールアドレス"
                  :rules="{required: (!email && !mobile_number), email, max: 100}"
                >
                  <v-text-field
                    v-model="email"
                    :error-messages="errors"
                    autocomplete="username"
                    label="メールアドレス"
                    prepend-icon="mdi-email"
                    placeholder="例）test@dxe.jp"
                    hide-details="auto"
                  >
                    <template v-slot:label>
                      <span>メールアドレス</span>
                      <span class="ml-1">
                        ({{ email?.length || 0 }} / 100)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="携帯番号"
                  :rules="{required: (!email && !mobile_number),numeric_hyphen_only: true, min: 2, max: 15}"
                >
                  <v-text-field
                    v-model="mobile_number"
                    :error-messages="errors"
                    autocomplete="username"
                    label="携帯番号"
                    placeholder="例）000-0000-0000"
                    prepend-icon="mdi-cellphone-basic"
                    hide-details="auto"
                    hint="携帯番号を「-」ハイフン「( )」込みで入力します"
                    persistent-hint
                  > 
                    <template v-slot:label>
                      <span>携帯番号</span>
                      <span class="ml-1">
                        ({{ mobile_number?.length || 0 }} / 15)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <template>
              <p class="red--text text-left">
                {{ userMessage }}
              </p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="toNext"
            >
              確認
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ForgetLoginIdForm',
  components: {},
  mixins: [],
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    emissionId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      userMessage: null,
      name: null,
      email: null,
      mobile_number: null,
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    // ...mapActions('DriverRecovery', {
    //   indexUser: 'index',
    // }),
    backButtonClickEvent () {
      this.$router.replace({ name: 'DriverSessions' })
    },
    toNext () {
      let $self = this
      this.$refs.emissionUserInfoFormValidator.validate().then((result) => {
        if (result) {
          $self.sendToNext()
        }
      })
    },
    sendToNext () {
      this.user.name = this.name
      this.user.email = this.email
      this.user.mobile_number = this.mobile_number

      this.$emit("my-click", this.user);
      this.$emit('toNextStep')
    },
  }
}
</script>

<style scoped>

</style>
